import { RefreshCw } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useIntegrationsList } from '@/lib/api/integrations'
import { usePromotionSyncWithPolling } from '@/lib/api/promotions'

interface WooCommerceSyncPromotionButtonProps {
    storeId: string
    onSyncComplete?: () => void
}

/**
 * Button component to sync promotions from WooCommerce
 * Only displays if a WooCommerce integration is enabled for the store
 */
export const WooCommerceSyncPromotionButton = ({ storeId, onSyncComplete }: WooCommerceSyncPromotionButtonProps) => {
    const { data: integrations } = useIntegrationsList(storeId)
    const { handleSync, isLoading } = usePromotionSyncWithPolling(onSyncComplete)

    const hasWooCommerceIntegration = integrations?.some(
        (integration) => integration.provider === 'woocommerce' && integration.enabled
    )

    if (!hasWooCommerceIntegration) {
        return null
    }

    return (
        <Button
            onClick={() => handleSync({ storeId })}
            disabled={isLoading}
            variant="outline"
            size="sm"
        >
            <RefreshCw className={isLoading ? 'animate-spin' : ''} />
            {isLoading ? 'Syncing...' : 'Sync from WooCommerce'}
        </Button>
    )
}
